import { render, staticRenderFns } from "./DeltaValue.vue?vue&type=template&id=c40d064e&"
import script from "./DeltaValue.vue?vue&type=script&lang=js&"
export * from "./DeltaValue.vue?vue&type=script&lang=js&"
import style0 from "./DeltaValue.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports